import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";

export const CloneButton = (props) => {
	const { label, handleOnClick, style, active, buttonIcon } = props;

	return (
		<Button
			variant="contained"
			style={{
				padding: "8px 34px",
				borderRadius: 40,
				backgroundColor: active ? "#4ea8ac" : "#eeeeee",
				borderColor: "#4ea8ac",
				color: active ? "white" : "black",
				textAlign: "center",
				whiteSpace: "nowrap",
				...style,
			}}
			onClick={() => {
				if (handleOnClick && !!active) {
					handleOnClick();
				}
			}}
			startIcon={buttonIcon}
		>
			{label}
		</Button>
	);
};

CloneButton.propTypes = {
	label: PropTypes.string,
	handleOnClick: PropTypes.func,
	style: PropTypes.object,
	active: PropTypes.bool,
	buttonIcon: PropTypes.object,
};

CloneButton.defaultProps = {
	active: true,
};
